import { z } from "zod";

// IMPORTANTE: os `value` devem bater EXATAMENTE com as opções da property
// `cartera_externo` no HubSpot (Settings → Properties → Contact → [Externo] Tamanho da Carteira).
export const CARTEIRA_OPTIONS = [
  { value: "ate1milhao", label: "Até R$ 1 milhão" },
  { value: "1a5milhoes", label: "R$ 1 a 5 milhões" },
  { value: "5a20milhoes", label: "R$ 5 a 20 milhões" },
  { value: "20a100milhoes", label: "R$ 20 a 100 milhões" },
  { value: "acima100milhoes", label: "Mais de R$ 100 milhões" },
] as const;

// Qualificador de certificação (padrão visto no form da Zuvia). Opcional —
// não bloqueia o envio. Os `value` viram a property `externo_certificacao` no
// HubSpot; se essa property ainda não existir lá, a Edge Function
// (api/parceiros-lead.ts) descarta o campo e reenvia sem quebrar o lead.
export const CERTIFICACAO_OPTIONS = [
  { value: "cpa10", label: "CPA-10" },
  { value: "cpa20", label: "CPA-20" },
  { value: "cea", label: "CEA" },
  { value: "cga", label: "CGA" },
  { value: "cfp", label: "CFP®" },
  { value: "cfa", label: "CFA" },
  { value: "aai", label: "AAI / Ancord" },
  { value: "outra", label: "Outra certificação" },
  { value: "nao_possuo", label: "Não possuo certificação" },
] as const;

export const parceirosFormSchema = z.object({
  fullname: z
    .string()
    .min(3, "Informe seu nome completo")
    .refine((v) => v.trim().includes(" "), {
      message: "Informe nome e sobrenome",
    }),
  email: z.string().email("E-mail inválido"),
  phone: z
    .string()
    .min(14, "Telefone com DDD: (XX) XXXXX-XXXX"),
  // Qualificador: só quem já atua no mercado libera o select de carteira.
  // Quem marca "nao" tem carteira_size setado como "nao_tem" automaticamente.
  ja_atua: z.enum(["sim", "nao"], {
    errorMap: () => ({ message: "Selecione uma opção" }),
  }),
  carteira_size: z.string().min(1, "Selecione uma faixa"),
  // Opcional — sem asterisco no form, igual ao "Possui Certificação?" da Zuvia.
  certificacao: z.string().optional(),
  lgpd_consent: z.literal(true, {
    errorMap: () => ({
      message: "Você precisa aceitar a Política de Privacidade",
    }),
  }),
});

export type ParceirosFormData = z.infer<typeof parceirosFormSchema>;
